import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdInfo } from 'src/app/shared/models/id-info.model';
import { LimitedMember } from 'src/app/shared/models/limited-member';
import { Member } from 'src/app/shared/profile/profile/member.model';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { AppService } from 'src/app/shared/services/app.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { CheckinDeviceService } from '../self-checkin/checkin-device.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../account/auth.service';
import { Location } from '@angular/common';
import QRCode from 'qrcode'

@Component({
    selector: 'app-fast-checkin',
    templateUrl: './fast-checkin.component.html',
    styleUrls: ['./fast-checkin.component.scss'],
    standalone: false
})
export class FastCheckinComponent implements OnInit, AfterViewInit {
  emailVerification = false;
  qrImage: string = '';
  userId: string;
  members: LimitedMember[] = [];
  isLoading: boolean = true;
  isConfirmed: boolean = false;
  verifyPhone: boolean = false;
  failedToVerify: boolean = true;
  dial_code: string = "+1";
  phoneNumber: string = '';
  QRCode: string = '';
  tenantId: string = '';
  isIdentity: boolean = false;
  isProfile: boolean = false;
  constructor(private profileService: ProfileService,
    public globalService: GlobalService,
    private appService: AppService,
    private _location: Location,
    private _router: Router,
    private route: ActivatedRoute, public devices: CheckinDeviceService, private tenants: TenantService, private auth: AuthService) { }

  loadError = false;

  resetHousehold() {
    this.userId = null;
    this.members = [];
    this.isConfirmed = false;
    this.loadError = false;
    this.QRCode = '';
    this.devices.clear();
  }

  async ngOnInit() {
    this.loadError = false;
    this.members = [];
    this.isConfirmed = false;
    try {
    this.isLoading = true;
    this.isIdentity = this.route.snapshot.params.function != undefined && this.route.snapshot.params.function.toLowerCase().trim() == 'identity'; // Subscription
    this.isProfile = this.route.snapshot.params.function != undefined && this.route.snapshot.params.function.toLowerCase().trim() == 'profile'; // Profile
    
    this.tenantId = this.route.snapshot.params.tenantId;
    localStorage.setItem('tenant', this.tenantId);
    const tenant = await this.tenants.getSimpleTenant();
    this.emailVerification = tenant.accountVerificationMethod === 'email';
    this.dial_code = '+' + (tenant.dialCode || 1);
    if (this.auth.user.value?.id && this.devices.read()?.userId !== this.auth.user.value.id) await this.devices.remember();
    if (this.isProfile == false) this.userId = this.devices.read()?.userId;
    if (!this.userId || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.userId)) this.userId = null;
    this.tenantId = this.route.snapshot.params.tenantId;
    localStorage.setItem('tenant', this.tenantId);
    this.globalService.selectedOption = "CHECKIN";

    if (this.userId != null && this.userId.length == 36 && this.isProfile != true) {
      this.isConfirmed = true;
      this.appService.sendToNative(this.userId, this.tenantId);
      await this.LoadMembers(this.userId);
    }
    this.isLoading = false;
    } catch (error) {
      if ([400, 401, 403, 404].includes(error?.status)) this.resetHousehold();
      else this.loadError = true;
    } finally {
      this.isLoading = false;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.globalService.title.push(this.globalService.screenHeader);
      if (this.route.snapshot.params.function == undefined)
        this.globalService.screenHeader = this.globalService.Get('FAST_CHECKIN');
      else
        this.globalService.screenHeader = "Identity Verification";
    });
  }

  async LoadMembers(userId) {
    this.members = await this.profileService.getLimitedMembers(userId);
    if (!this.members?.length) throw new Error("No household members returned");
    this.QRCode = '@' + this.userId + '#' + this.members.filter(a => a.checked == true).map(b => b.id).join('X') + '%';
    this.qrImage = await QRCode.toDataURL(this.QRCode);
  }

  emailAccess() { void this._router.navigate(['/' + this.tenantId + '/email-access'], {queryParams:{returnUrl:this._router.url}}); }

  clearCellPhone() {
  }

  failedVerification() {
    this.verifyPhone = false;
    this.failedToVerify = true;
  }

  async ConfirmCellPhone(phoneNumber) {
    this.isLoading = true;
    this.loadError = false;
    try {
    this.phoneNumber = phoneNumber;
    var user = await this.profileService.getUserIdByPhoneNumber(phoneNumber);
    this.userId = user?.['userId'];
    if (!this.userId || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.userId)) { this.resetHousehold(); this.loadError = true; return; }
    if (this.userId != null && this.userId.length == 36) {
      this.isConfirmed = true;
      let tenant = localStorage.getItem('tenant');
      localStorage.setItem('CSBarcodeID', this.userId);
      this.appService.sendToNative(this.userId, tenant);
      await this.LoadMembers(this.userId);
      this.isLoading = false;
      if (this.isProfile == true)
        this._router.navigate(['/myprofile']);
    }
    } catch (error) {
      if ([400, 401, 403, 404].includes(error?.status)) this.resetHousehold();
      this.loadError = true;
    } finally {
      this.isLoading = false;
    }
  }

  async toggleMember(member) {
    member['checked'] = !member['checked'];
    this.QRCode = '';
    if (this.members.filter(a => a.checked == true).length > 0)
      this.QRCode = '@' + this.userId + '#' + this.members.filter(a => a.checked == true).map(b => b.id).join('X') + '%';
      this.qrImage = await QRCode.toDataURL(this.QRCode);
  }

  goIOS() {
    window.location.href =
      'https://apps.apple.com/us/app/church-services/id6743777822';
  }

  // goAndroid() {
  //   const packageName = 'org.church_services.main.twa';

  //   const intentUrl =
  //     `intent://#Intent;` +
  //     `package=${packageName};` +
  //     `scheme=https;` +
  //     `S.browser_fallback_url=https://play.google.com/store/apps/details?id=${packageName};` +
  //     `end`;

  //   window.location.href = intentUrl;
  // }

  goAndroid() {
    window.location.href =
      'https://play.google.com/store/apps/details?id=org.church_services.main.twa&pcampaignid=web_share';
  }

  goHome() {
    this._router.navigate(['\home']);
  }
}
